import { createSlice } from "@reduxjs/toolkit";
import {
  getRequests,
  addNewRequest,
  updateRequest,
  deleteRequest,
} from "./thunk";

export const initialState = {
  userRequests: [],
  error: {},
  isLoading: false,
  isRequestsSuccess: false,
  isRequestsFailed: false,
};

const requestsSlice = createSlice({
  name: "userRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //==================================[ /getRequests/ ]=======================================
    builder.addCase(getRequests.pending, (state) => {
      state.isLoading = true;
      state.isRequestsSuccess = false;
      state.error = null;
    });
    builder.addCase(getRequests.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isRequestsSuccess = true;
      state.userRequests = action.payload;
    });
    builder.addCase(getRequests.rejected, (state, action) => {
      state.isLoading = false;
      state.isRequestsSuccess = false;
      state.error = action.error.message;
    });

    builder.addCase(addNewRequest.fulfilled, (state, action) => {
      state.userRequests = [...state.userRequests, action.payload];
      state.isRequestAdd = true;
      state.isRequestAddFail = false;
    });

    builder.addCase(addNewRequest.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isRequestAdd = false;
      state.isRequestAddFail = true;
    });

    builder.addCase(updateRequest.fulfilled, (state, action) => {
      state.userRequests = state.userRequests.map((request) =>
        request._id.toString() === action.payload._id.toString()
          ? { ...request, ...action.payload }
          : request
      );
      state.isRequestUpdate = true;
      state.isRequestUpdateFail = false;
    });

    builder.addCase(updateRequest.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isRequestUpdate = false;
      state.isRequestUpdateFail = true;
    });

    builder.addCase(deleteRequest.fulfilled, (state, action) => {
      state.userRequests = (state.userRequests || []).filter(
        (request) => request._id.toString() !== action.payload.id.toString()
      );

      state.isRequestDelete = true;
      state.isRequestDeleteFail = false;
    });

    builder.addCase(deleteRequest.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isRequestDelete = false;
      state.isRequestDeleteFail = true;
    });
  },
});

export default requestsSlice.reducer;
